import { render } from "./ShopifyIntegrationSettings.vue?vue&type=template&id=67202d52"
import script from "./ShopifyIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./ShopifyIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__